import { ResourceElement } from "./ResourceElement";
import type { Material } from '@phdsoft/three';


export class ThicknessColorTable extends ResourceElement {
    private _thickness: number;
    public get thickness(): number {
        return this._thickness;
    }
    public set thickness(v: number) {
        this._thickness = v;
    }

    private _Color: string;
    public get Color(): string {
        return this._Color;
    }
    public set Color(v: string) {
        this._Color = v;
    }

    private _renderMaterial: Material;
    public get renderMaterial(): Material {
        return this._renderMaterial;
    }
    public set renderMaterial(v: Material) {
        this._renderMaterial = v;
    }


    constructor(material: any) {
        super();
        this._Color = material.Color;
        this._thickness = material.Thickness;
    }
}